import * as CubiqTS from "shared/cubiq-model-multi-asset";

import { DateAdapter } from "../DateAdapter";

// String types that are sortable as an Int32 in C++ module
export class ExpiryAdapter extends DateAdapter {
  constructor() {
    super();
  }

  retrieveData(order: any, columnProperty: string): string {
    let expiryType: CubiqTS.OrderExpiryType = order.expiryType;
    if (expiryType == CubiqTS.OrderExpiryType.GTC) {
      return "GTC";
    }
    if (order[columnProperty]) {
      if (order.expiryAlias && order.expiryAlias != "CUSTOM") {
        return order.expiryAlias + " " + super.retrieveData(order, columnProperty);
      }
      return super.retrieveData(order, columnProperty);
    }
    return "";
  }
}
